import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mediatypeIcon' })

export class MediatypeIconPipe implements PipeTransform {

	constructor() {

	}

	transform(mediatype: string): string {
		let icon: string;

		switch (mediatype) {
			case 'video':
				icon = 'film';
				break;
			case 'image':
				icon = 'image';
				break;
			case 'audio':
				icon = 'volume-up';
				break;
			case 'interactive':
				icon = 'cog';
				break;
			case 'document':
				icon = 'file';
				break;
			default:
				return;
		}

		const ret = '<i title="' + mediatype + '" class="fa fa-' + icon + '"></i>';

		return ret;
	}
}
